import {
  AdasBox,
  AdasButton,
  AdasCheckbox,
  AdasFormGroup,
  AdasTypography,
  AdasModal,
  AdasImage,
  AdasFormControlLabel
} from '@components/wrapper-components'
import DiagnosticTree from '../../assets/images/diagnostic-tree.jpeg'
import { X } from 'lucide-react'
import './DiagnosticTreeViewer.css'
import { useCallback, useState } from 'react'

export const DiagnosticTreeViewer = ({ isOpen, closeModal, handleNextButtonClick }) => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false)

  const handleCloseModal = useCallback(() => {
    setIsButtonEnabled(false)
    closeModal()
  }, [closeModal])

  return (
    <>
      <AdasModal
        open={isOpen}
        onClose={handleCloseModal}
        aria-labelledby='responsive-modal-title'
        aria-describedby='responsive-modal-description'
        className='modalContainer'
      >
        <AdasBox className='modalContent'>
          <AdasBox className='modal-title-container'>
            <AdasTypography id='responsive-modal-title' component='h2' className='title'>
              Failed Calibration Diagnostic Tree
            </AdasTypography>
            <AdasButton buttonType='iconButton' className='modal-close-btn' onClick={handleCloseModal}>
              <X />
            </AdasButton>
          </AdasBox>
          <AdasBox className='imageContainer'>
            <AdasImage src={DiagnosticTree} alt='Modal' className='image w-full' />
          </AdasBox>
          <AdasBox className='buttonSection'>
            <AdasBox className='buttonContainer'>
              <AdasFormGroup>
                <AdasFormControlLabel
                  control={
                    <AdasCheckbox
                      checked={isButtonEnabled}
                      onChange={() => setIsButtonEnabled(!isButtonEnabled)}
                      name='reviewDiagnosticTree'
                    />
                  }
                  label='Review the Failed Calibration Diagnostic Tree'
                />
              </AdasFormGroup>
            </AdasBox>
            <AdasBox className='doneButtonContainer'>
              <AdasButton variant='outlined' color='primary' aria-label='goback' className='h-[35px]' onClick={handleCloseModal}>
                GO BACK
              </AdasButton>
              <AdasButton
                variant='contained'
                color='primary'
                disabled={!isButtonEnabled}
                onClick={handleNextButtonClick}
                className='h-[35px]'
              >
                NEXT
              </AdasButton>
            </AdasBox>
          </AdasBox>
        </AdasBox>
      </AdasModal>
    </>
  )
}
